module.exports = __webpack_public_path__ + "static/media/Memories.f0891aa8.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Memories.woff
// module id = 2115
// module chunks = 53